import { AlertCircle, Check, X } from "@untitledui/icons";
import { Toaster as SonnerToaster, toast as sonnerToast } from "sonner";
import { IconNotification, type IconNotificationProps } from "@/components/application/notifications/notifications";
import { Toaster } from "@/components/ui/toaster";

export const ToastProvider = ({ children }: { children: React.ReactNode }) => {
  return (
    <>
      {children}
      <Toaster />
      <SonnerToaster expand toastOptions={{}} />
    </>
  );
};

export function toast(
  title: React.ReactNode,
  props: Omit<IconNotificationProps, "title"> = {},
  options: {
    position?: "top-left" | "top-center" | "top-right" | "bottom-left" | "bottom-center" | "bottom-right";
    duration?: number;
  } = {},
) {
  return sonnerToast.custom(
    (id) => (
      <IconNotification
        title={title}
        {...props}
        onClose={() => {
          sonnerToast.dismiss(id);
          props.onClose?.();
        }}
        onConfirm={() => {
          sonnerToast.dismiss(id);
          props.onConfirm?.();
        }}
      />
    ),
    { className: "pointer-events-auto", ...options },
  );
}

export function success(
  title: React.ReactNode,
  props: Omit<IconNotificationProps, "title"> = {},
  position:
    | "top-left"
    | "top-center"
    | "top-right"
    | "bottom-left"
    | "bottom-center"
    | "bottom-right" = "bottom-center",
) {
  return toast(title, { ...props, color: "gray", icon: Check }, { position });
}

export function error(
  title: React.ReactNode,
  props: Omit<IconNotificationProps, "title"> = {},
  options: Parameters<typeof toast>[2] = {},
) {
  return toast(title, { ...props, color: "error", icon: X }, options);
}

export function warning(title: React.ReactNode, props: Omit<IconNotificationProps, "title"> = {}) {
  return toast(title, { ...props, color: "warning", icon: AlertCircle });
}
